import { useContext } from 'react';
import { TermFilterContext } from '@/containers/Project.Terms';

export const useHighlightsOpen = () => {
  const { highlightTerm } = useContext(TermFilterContext);

  return !!highlightTerm;
};